import { QueryClient, QueryClientProvider } from 'react-query';
import './App.css';
import './scss/global.scss';
import BookingDayTable from './components/BookingDayTable';
import WeekCalendar from './components/WeekCalendar';
import 'moment/locale/uk';
import Modal from './components/Modal';
import { BookingProvider } from './context';
import InfoRow from './components/InfoRow';
import AcceptanceRow from './components/AcceptanceRow';
import { isMobile } from 'react-device-detect';
import ModalSuccess from './components/ModalSuccess';
import MobileInfoRow from './components/MobileInfoRow';

const queryClient = new QueryClient();

function App() {
  return (
    <BookingProvider>
      <QueryClientProvider client={queryClient}>
        <div className="App pb-[12rem] md:pb-[6rem]">
          <WeekCalendar />
          {isMobile ? <MobileInfoRow /> : <InfoRow />}
          <BookingDayTable />
          <Modal />
          <ModalSuccess />
          <AcceptanceRow />
        </div>
      </QueryClientProvider>
    </BookingProvider>
  );
}

export default App;
